import Backbone from 'backbone';

export default Backbone.View.extend({
  initialize(o) {
    this.model = o.model;
    this.parent = o.parent;
    this.listenTo(this.model, 'change:is_selected', this.updateActive);
  },

  events: {
    'click .panel-item': 'categorySelected'
  },
  updateActive() {
    if (this.model.get('is_selected')) {
      this.$el.addClass('is_selected');
    } else {
      this.$el.removeClass('is_selected');
    }
  },

  categorySelected() {
    if (!this.model.get('is_selected')) {
      var id = this.model.get('id');
      this.model.collection.deactivateAll(id);
      this.model.set('is_selected', true);
      this.parent.trigger('categorySelected', id);
    }
  },

  render: function() {
    this.$el.empty();
    this.$el.addClass('panel-item');
    if (this.model.get('is_selected')) {
      this.$el.addClass('is_selected');
      this.parent.trigger('categorySelected', this.model.get('id'));
    }
    this.$el.text(this.model.get('name'));

    return this;
  }
});
